
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import EnhancedSEO from '@/components/EnhancedSEO';
import Breadcrumb from '@/components/Breadcrumb';

interface ValorisationPageLayoutProps {
  title: string;
  description: string;
  canonical: string;
  keywords: string;
  structuredData?: Record<string, any>;
  heroTitle: string;
  heroSubtitle: string;
  heroImage?: string;
  breadcrumbItems: Array<{ label: string; href: string; current?: boolean }>;
  children: React.ReactNode;
}

const ValorisationPageLayout: React.FC<ValorisationPageLayoutProps> = ({
  title,
  description,
  canonical,
  keywords,
  structuredData,
  heroTitle,
  heroSubtitle,
  heroImage,
  breadcrumbItems,
  children
}) => {
  return (
    <div className="min-h-screen flex flex-col">
      <EnhancedSEO
        title={title}
        description={description}
        canonical={canonical}
        keywords={keywords}
        structuredData={structuredData}
      />

      <Navbar />

      {/* Hero Section */}
      <section className={`relative py-20 ${heroImage ? 'bg-cover bg-center' : 'bg-gradient-to-br from-fabre-green via-fabre-teal to-fabre-darkgreen'} text-white`} 
               style={heroImage ? { backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${heroImage})` } : {}}>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl">
            <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6 leading-tight">
              {heroTitle}
            </h1>
            <p className="text-xl md:text-2xl opacity-90 leading-relaxed">
              {heroSubtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <nav className="bg-gray-50 py-3 border-b border-gray-200">
        <div className="container mx-auto px-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default ValorisationPageLayout;
